<template>
<div class="copyright">
  <div class="container">
    <div class="row">
        <span class="item">© 2019-{{ year }} Bennu All Rights Reserved</span> |
        <span class="item beian">
          <a href="http://beian.miit.gov.cn/" target="_blank">
            粤ICP备18076536号-1 </a>
        </span> |
        <span><img src="../../assets/beian.png"></span>
        <span class="item beian">
          <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44011302001788" target="_blank">
            粤公网安备44011302001788号 </a>
        </span>
      </div>
  </div>
</div>
</template>

<script>
var year = '2019';
export default {
  name: 'Footer',
  data() {
    return {
      year
    };
  },
  mounted() {
    this.year = new Date().getFullYear();
  }
};
</script>

<style scoped>
.copyright {
  background: #111;
  text-align: center;
  color: #555;
  padding-top: 14px;
  padding-bottom: 20px;
  border-top: 1px solid #303030;
}
.copyright .item {
  height: 20px;
}
.beian a {
  color: #555;
}
</style>
